<template>
  <form @submit.prevent="submit()">
    <b-row>
      <b-col cols="12" lg="4">
        <div :class="['form-group', isInvalid('title') ? 'has-danger' : '']">
          <label
                  for="excmcasetype_title"
                  class="form-control-label">{{$t('views.excmcasetype.form.title')}}:</label>
          <input
                  id="excmcasetype_title"
                  v-model="item.title"
                  :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('title', $event.target.value)">
          <div
                  v-if="isInvalid('title')"
                  class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div :class="['form-group', isInvalid('subtitle') ? 'has-danger' : '']">
          <label
                  for="excmcasetype_subtitle"
                  class="form-control-label">{{$t('views.excmcasetype.form.subtitle')}}:</label>
          <input
                  id="excmcasetype_subtitle"
                  v-model="item.subtitle"
                  :class="['form-control', isInvalid('subtitle') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('subtitle', $event.target.value)">
          <div
                  v-if="isInvalid('subtitle')"
                  class="invalid-feedback">{{ violations.subtitle }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div :class="['form-group', isInvalid('defaultTask') ? 'has-danger' : '']">
          <label
                  for="excmcasetype_defaultTask"
                  class="form-control-label">{{$t('views.excmcasetype.form.defaultTask')}}:</label>
          <fg-input :error="violations.defaultTask">
            <el-select
                    id="excmcasetype_defaultTask"
                    :class="['select-default', isInvalid('defaultTask') ? 'select-danger' : '']"
                    :placeholder="$t('views.excmcasetype.form.defaultTask')"
                    filterable
                    v-model="item.defaultTask">
              <el-option v-for="option in EXCMTaskTypes"
                         class="select-default"
                         :value="option['value']"
                         :label="option['text']"
                         :key="option['value']">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="6">
        <div :class="['form-group', isInvalid('duration') ? 'has-danger' : '']">
          <label
            for="excmcasetype_duration"
            class="form-control-label">{{$t('views.excmtasktype.form.duration')}}:</label>
          <input
            id="excmcasetype_duration"
            v-model="item.duration"
            :class="['form-control', isInvalid('duration') ? 'is-invalid' : '']"
            type="number"
            placeholder=""
            @input="handleUpdateField('duration', $event.target.value)">
          <div
            v-if="isInvalid('duration')"
            class="invalid-feedback">{{ violations.duration }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="6">
        <div :class="['form-group', isInvalid('durationUnit') ? 'has-danger' : '']">
          <label
            for="excmcasetype_durationUnit"
            class="form-control-label">{{$t('views.excmtasktype.form.durationUnit')}}:</label>
          <fg-input :error="violations.durationUnit">
            <el-select
              id="excmcasetype_durationUnit"
              :class="['select-default', isInvalid('durationUnit') ? 'select-danger' : '']"
              filterable
              v-model="item.durationUnit">
              <el-option v-for="option in timeUnits"
                         class="select-default"
                         :value="option.value"
                         :label="option.text"
                         :key="option.value">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="6">
        <div :class="['form-group', isInvalid('emailEnable') ? 'has-danger' : '']">
          <label
                  for="excmcasetype_emailEnable"
                  class="form-control-label">{{$t('views.excmcasetype.form.emailEnable')}}:</label>
          <b-form-group>
            <b-form-radio-group buttons id="hourlySettlement" button-variant="outline-primary" v-model="item.emailEnable" name="hourlySettlement">
              <b-form-radio :value="0" variant="success">{{$t('buttons.no')}}</b-form-radio>
              <b-form-radio :value="1" variant="info">{{$t('buttons.yes')}}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <div
                  v-if="isInvalid('emailEnable')"
                  class="invalid-feedback">{{ violations.emailEnable }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="6">
        <div :class="['form-group', isInvalid('emailTitle') ? 'has-danger' : '']">
          <label
                  for="excmcasetype_emailTitle"
                  class="form-control-label">{{$t('views.excmcasetype.form.emailTitle')}}:</label>
          <input
                  id="excmcasetype_emailTitle"
                  v-model="item.emailTitle"
                  :class="['form-control', isInvalid('emailTitle') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('emailTitle', $event.target.value)">
          <div
                  v-if="isInvalid('emailTitle')"
                  class="invalid-feedback">{{ violations.emailTitle }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div :class="['form-group', isInvalid('emailContent') ? 'has-danger' : '']">
          <label
                  for="excmcasetype_emailContent"
                  class="form-control-label">{{$t('views.excmcasetype.form.emailContent')}}:</label>
          <textarea
                  id="excmcasetype_emailContent"
                  v-model="item.emailContent"
                  :class="['form-control', isInvalid('emailContent') ? 'is-invalid' : '']"
                  placeholder=""
                  @input="handleUpdateField('emailContent', $event.target.value)"
                  rows="3"
          >
      </textarea>
          <div
                  v-if="isInvalid('emailContent')"
                  class="invalid-feedback">{{ violations.emailContent }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
<!--      CASETYPE PARAMS START-->
<!--      notes-->
      <b-col sm="4" lg="2">
          <label
            for="enableNotes"
            class="form-control-label">{{$t('views.excmcasetype.form.enableNotes')}}:</label>
          <b-form-group>
            <b-form-radio-group buttons id="enableNotes" button-variant="outline-primary" v-model="item.caseParams.hasNotes" name="enableNotes">
              <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
              <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
      </b-col>
<!--      categorization of problems-->
      <b-col sm="4" lg="2">
          <label
            for="enableCategorization"
            class="form-control-label">{{$t('views.excmcasetype.form.enableCategorization')}}:</label>
          <b-form-group>
            <b-form-radio-group buttons id="enableCategorization" button-variant="outline-primary" v-model="item.caseParams.hasCategorization" name="enableCategorization">
              <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
              <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
      </b-col>
<!--      timeline-->
      <b-col sm="4" lg="2">
          <label
            for="enableTimeline"
            class="form-control-label">{{$t('views.excmcasetype.form.enableTimeline')}}:</label>
          <b-form-group>
            <b-form-radio-group buttons id="enableTimeline" button-variant="outline-primary" v-model="item.caseParams.hasTimeline" name="enableTimeline">
              <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
              <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
      </b-col>
<!--    tickets-->
      <b-col sm="4" lg="2">
        <label
          for="enable-ticket"
          class="form-control-label">{{$t('views.excmcasetype.form.enableTicket')}}:</label>
        <b-form-group>
          <b-form-radio-group buttons id="enable-ticket" button-variant="outline-primary" v-model="item.caseParams.hasTicket" name="enable-ticket">
            <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
            <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
<!--      client-->
      <b-col sm="4" lg="2">
        <label
          for="enable-client"
          class="form-control-label">{{$t('views.excmcasetype.form.enableClient')}}:</label>
        <b-form-group>
          <b-form-radio-group buttons id="enable-client" button-variant="outline-primary" v-model="item.caseParams.hasClient" name="enable-client">
            <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
            <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
<!--    device-->
      <b-col sm="4" lg="2">
        <label
          for="enable-device"
          class="form-control-label">{{$t('views.excmcasetype.form.enableDevice')}}:</label>
        <b-form-group>
          <b-form-radio-group buttons id="enable-device" button-variant="outline-primary" v-model="item.caseParams.hasDevice" name="enable-device">
            <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
            <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
<!--    agreement-->
      <b-col sm="4" lg="2">
        <label
          for="enable-agreement"
          class="form-control-label">{{$t('views.excmcasetype.form.enableAgreement')}}:</label>
        <b-form-group>
          <b-form-radio-group buttons id="enable-agreement" button-variant="outline-primary" v-model="item.caseParams.hasAgreement" name="enable-agreement">
            <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
            <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
<!--    SLA-->
      <b-col sm="4" lg="2">
        <label
          for="enable-sla"
          class="form-control-label">{{$t('views.excmcasetype.form.enableSLA')}}:</label>
        <b-form-group>
          <b-form-radio-group buttons id="enable-sla" button-variant="outline-primary" v-model="item.caseParams.hasSLA" name="enable-sla">
            <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
            <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    <!--    PARTNER HANDLOWY-->
    <b-col sm="4" lg="2">
      <label
        for="enable-partner"
        class="form-control-label">{{$t('views.excmcasetype.form.enablePartner')}}:</label>
      <b-form-group>
        <b-form-radio-group buttons id="enable-partner" button-variant="outline-primary" v-model="item.caseParams.hasPartner" name="enable-partner">
          <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
          <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-col>
    <!--    PRIORYTET -->
    <b-col sm="4" lg="2">
      <label
        for="enable-priority"
        class="form-control-label">{{$t('views.excmcase.form.idPriority')}}:</label>
      <b-form-group>
        <b-form-radio-group buttons id="enable-priority" button-variant="outline-primary" v-model="item.caseParams.hasPriority" name="enable-priority">
          <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
          <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-col>
    <!--    RODZAJ ZLECENIA -->
    <b-col sm="4" lg="2">
      <label
        for="enable-genre"
        class="form-control-label">{{$t('views.excmcase.form.caseGenre')}}:</label>
      <b-form-group>
        <b-form-radio-group buttons id="enable-genre" button-variant="outline-primary" v-model="item.caseParams.hasGenre" name="enable-priority">
          <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
          <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-col>
  </b-row>
    <b-row class="mb-3">
      <b-col>
        <label>{{$t("views.exsbinvoices.form.batchNumber")}}:</label>
        <model-select v-model="item.batchNumber" :options="batchNumbersOptions" name="batchNumber" id="batchNumber" :placeholder="$t('views.exsbinvoices.form.batchNumber')">
        </model-select>
      </b-col>
    </b-row>
    <b-row class="mb-3" v-if="roleOptions">
      <b-col>
        <label>{{$t("views.excmcase.form.keyRoles")}}:</label>
        <multi-select :options="roleOptions" :selected-options="keyRoles" @select="selectKeyRolesHandler"></multi-select>
      </b-col>
    </b-row>
    <b-row class="mb-3" v-if="EXCMTaskTypes">
      <b-col>
        <label>{{$t("views.excmcase.form.keyTaskTypes")}}:</label>
        <multi-select :options="EXCMTaskTypes" :selected-options="keyTaskTypes" @select="selectKeyTaskTypeHandler"></multi-select>
      </b-col>
    </b-row>
    <b-row v-if="item.customFields && item.customFields.length > 0 && (routeName !== 'EXCMCaseTypeShow' && routeName !== 'EXCMTaskTypeShow')" class="mt-3">
      <b-col>
        <b-row>
          <b-col>
            <h6>{{ $t('views.excmcasetype.form.customFields') }}:</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr class="mt-1 mb-1">
          </b-col>
        </b-row>
        <b-row v-for="(customField, index) in item.customFields" v-bind:key="'customField-' + index">
          <b-col>
            <CustomField :item="customField" :index="index" :violations="violations" :items="item.customFields"></CustomField>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="routeName !== 'EXCMCaseTypeShow' && routeName !== 'EXCMTaskTypeShow'">
      <b-col>
        <b-btn class="btn btn-success" @click="addNewField()">{{ $t('views.excmcasetype.form.addNewField') }}</b-btn>
      </b-col>
    </b-row>
    <b-row v-if="(routeName === 'EXCMCaseTypeShow' || routeName === 'EXCMTaskTypeShow') && !isLoadingUpdate">
      <b-col>
        <div class="float-right">
          <button type="submit" class="btn btn-success">{{$t('buttons.save')}}</button>
          <b-btn class="btn btn-secondary" @click="cancelAction()">{{ $t('buttons.close') }}</b-btn>
        </div>
      </b-col>
    </b-row>
    <b-row v-else-if="!isLoadingUpdate">
      <b-col>
        <button type="submit" class="btn btn-success">{{$t('buttons.submit')}}</button>
      </b-col>
    </b-row>
    <CustomFieldAddModal :fieldTypes="fieldTypes"></CustomFieldAddModal>
    <CustomFieldEditModal :fieldTypes="fieldTypes"></CustomFieldEditModal>
    <CustomFieldValueAddModal></CustomFieldValueAddModal>
    <CustomFieldValueEditModal></CustomFieldValueEditModal>
  </form>
</template>

<script>
import CustomField from './components/CustomFieldValue/CustomField'
import CustomFieldAddModal from './components/CustomFieldValue/modal/CustomFieldAddModal'
import CustomFieldEditModal from './components/CustomFieldValue/modal/CustomFieldEditModal'
import CustomFieldValueAddModal from './components/CustomFieldValue/modal/CustomFieldValueAddModal'
import CustomFieldValueEditModal from './components/CustomFieldValue/modal/CustomFieldValueEditModal'
import { mapActions, mapGetters } from 'vuex'
import { ModelSelect, MultiSelect } from 'vue-search-select'
import ApiService from '../../../../utils/ApiService'
import getId from '@/utils/getIdFromLink'
export default {
  components: {
    CustomField,
    CustomFieldAddModal,
    CustomFieldEditModal,
    CustomFieldValueAddModal,
    CustomFieldValueEditModal,
    ModelSelect,
    MultiSelect
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      keyTaskTypes: [],
      lastSelectedKeyTaskType: {},
      EXCMTaskTypes: [],
      roleOptions: [],
      keyRoles: [],
      lastSelectedKeyRole: {},
      routeName: '',
      fieldTypes: [
        {
          name: this.$t('fieldTypes.input'),
          value: 'input'
        },
        {
          name: this.$t('fieldTypes.select'),
          value: 'select'
        },
        {
          name: this.$t('fieldTypes.datetime'),
          value: 'datetime'
        },
        {
          name: this.$t('fieldTypes.multiSelect'),
          value: 'multiSelect'
        },
        {
          name: this.$t('fieldTypes.inputFormatted'),
          value: 'inputFormatted'
        },
        {
          name: this.$t('fieldTypes.itemsCollection'),
          value: 'itemsCollection'
        },
        {
          name: this.$t('fieldTypes.idUserData'),
          value: 'idUserData'
        }
      ],
      timeUnits: [
        { value: 1, text: this.$t('global.timeMeasures.minutes') },
        { value: 2, text: this.$t('global.timeMeasures.hours') },
        { value: 3, text: this.$t('global.timeMeasures.days') },
        { value: 4, text: this.$t('global.timeMeasures.workDays') },
        { value: 5, text: this.$t('global.timeMeasures.workHours') }
      ]
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },

    isLoadingUpdate () {
      return this.$store.state.excmcasetype.update.isLoading
    },

    customFieldObject () {
      return this.$store.state.modals.customField.create.customFieldObject
    },
    customFieldObjectUpdated () {
      return this.$store.state.modals.customField.update.customFieldObjectUpdated
    },
    indexUpdated () {
      return this.$store.state.modals.customField.update.indexUpdated
    },
    batchNumbersOptions () {
      let array = []
      array.push({ value: null, text: this.$t('views.exsbinvoices.form.noBatchNumber') })
      if (this.batchNumbers && this.batchNumbers.length > 0) {
        this.batchNumbers.forEach((entry) => {
          if (entry.numerationType === 3) {
            array.push({ value: entry.value, text: entry.text })
          }
        })
      }
      return array
    },
    ...mapGetters({
      batchNumbers: 'exsbinvoice/list/batchNumberOptions'
    })
  },

  watch: {
    customFieldObject: function (field) {
      if (field && Object.entries(field).length > 0) {
        this.item.customFields.push(field)
        this.$store.state.modals.customField.create.customFieldObject = {}
      }
    },
    customFieldObjectUpdated: function (val) {
      this.handleUpdatedCustomField()
    },
    indexUpdated: function (val) {
      this.handleUpdatedCustomField()
    }
  },
  created () {
    this.routeName = this.$route.name
    this.getEXCMTaskTypes()
    this.getRoles()
    this.getBatchNumbers()
  },
  methods: {
    cancelAction () {
      this.$store.state.modals.caseType.update.close = 1
    },
    handleUpdatedCustomField () {
      if (this.customFieldObjectUpdated && Object.entries(this.customFieldObjectUpdated).length > 0 && this.indexUpdated > -1) {
        this.item.customFields.splice(this.indexUpdated, 1, this.customFieldObjectUpdated)
        this.$store.state.modals.customField.update.indexUpdated = -1
        this.$store.state.modals.customField.update.customFieldObjectUpdated = {}
      }
    },
    addNewField () {
      this.$store.state.modals.customField.create.show = 1
      this.$store.state.modals.customField.create.parent = this.item
    },
    initialKeyTaskTypeHandler () {
      if (this.item.keyTaskTypes) {
        this.keyTaskTypes = this.item.keyTaskTypes.map(role => {
          return this.EXCMTaskTypes.find(option => getId(option.value) === role)
        })
      }
    },
    async getEXCMTaskTypes () {
      const response = await new ApiService('e_x_c_m_task_types', { pagination: false, state: 1 }).getResults()
      this.EXCMTaskTypes = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title + (entry.idCasesType ? ' (' + entry.idCasesType.title + ')' : '')
        }
      })
      this.initialKeyTaskTypeHandler()
    },
    initialKeyRolesHandler () {
      if (this.item.keyRoles) {
        this.keyRoles = this.item.keyRoles.map(role => {
          return this.roleOptions.find(option => option.value === role)
        })
      }
    },
    async getRoles () {
      let params = {
        pagination: false,
        state: 1
      }
      const response = await new ApiService('client_types', params).getResults()
      this.roleOptions = response.items.map(entry => {
        return {
          value: getId(entry['@id']),
          text: entry.title
        }
      })
      this.initialKeyRolesHandler()
    },
    selectKeyTaskTypeHandler (keyTaskTypes, lastSelectedKeyTaskType) {
      this.keyTaskTypes = keyTaskTypes
      this.item.keyTaskTypes = keyTaskTypes.map(taskType => getId(taskType.value))
      this.lastSelectedKeyTaskType = lastSelectedKeyTaskType
    },
    selectKeyRolesHandler (keyRoles, lastSelectedKeyRole) {
      this.keyRoles = keyRoles
      this.item.keyRoles = keyRoles.map(role => getId(role.value))
      this.lastSelectedKeyRole = lastSelectedKeyRole
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    submit () {
      if (typeof this.item.duration === 'string') this.item.duration = parseInt(this.item.duration)
      this.handleSubmit(this.item)
    },
    ...mapActions({
      getBatchNumbers: 'exsbinvoice/list/fetchBatchNumberOptions'
    })
  }
}
</script>
